import React, { useEffect, useState, useCallback } from "react";
import Layout from "../components/Layout";
import client, { apiErr } from "../lib/api";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { ScoresTab } from "../components/workforce/ScoresTab";
import { SuggestionsTab } from "../components/workforce/SuggestionsTab";
import { RewardsTab } from "../components/workforce/RewardsTab";
import { LeadHistoryTab } from "../components/workforce/LeadHistoryTab";
import { DutyStrip } from "../components/workforce/DutyStrip";

const TABS = [["scores", "Daily Scores"], ["suggestions", "Lead Share Suggestions"], ["rewards", "Rewards"], ["history", "Lead History"]];

function Zones({ z }) {
  return (
    <div className="grid grid-cols-3 gap-2 mb-5" data-testid="wf-zone-summary">
      {[["green", "Green", "text-bull"], ["yellow", "Yellow", "text-[#eab308]"], ["red", "Red", "text-bear"]].map(([k, l, c]) => (
        <div key={k} className="surface p-3 sm:p-4"><div className="text-[10px] uppercase tracking-widest text-slate-500">{l} zone</div><div className={`font-mono text-2xl sm:text-3xl ${c}`} data-testid={`wf-count-${k}`}>{z?.[k] ?? 0}</div></div>
      ))}
    </div>
  );
}

export default function Workforce() {
  const [tab, setTab] = useState("scores");
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => client.get("/workforce/overview").then(({ data }) => setData(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const run = async () => {
    setBusy(true);
    const before = data?.review?.at;
    try {
      await client.post("/workforce/run");
      toast.success("AI scoring shuru — 1-2 min lagenge");
      let done = false;
      for (let i = 0; i < 40 && !done; i++) {
        await new Promise((r) => setTimeout(r, 5000));
        const { data: d } = await client.get("/workforce/overview");
        if (d.review?.at && d.review.at !== before) { setData(d); toast.success("Scores updated"); done = true; }
      }
      if (!done) toast.error("Scoring me der ho rahi hai — thodi der baad page refresh karein");
    } catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  return (
    <Layout title="Lead Workforce">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-4">
        <p className="text-sm text-slate-400 flex-1">Partners ka daily score (lead pick speed, follow-ups, interested, converted). Har raat 9:30 baje AI review + kal ke lead share ka suggestion.{data?.date && <span className="text-slate-500"> Last: {data.date}</span>}</p>
        <button onClick={run} disabled={busy} className="btn-gold px-4 py-2 text-xs flex items-center justify-center gap-2 whitespace-nowrap disabled:opacity-60" data-testid="wf-run-now">
          <RefreshCw size={14} className={busy ? "animate-spin" : ""} />{busy ? "AI scoring..." : "Score now"}
        </button>
      </div>
      {data?.pending && tab !== "suggestions" && (
        <button onClick={() => setTab("suggestions")} className="w-full mb-4 surface border-gold/50 p-3 text-left text-sm text-gold" data-testid="wf-pending-banner">Kal ke lead share ka suggestion ({data.pending.date}) approve hona baaki hai →</button>
      )}
      <DutyStrip />
      <Zones z={data?.zones} />
      <div className="flex gap-1 mb-4 border-b border-[color:var(--border-subtle)] overflow-x-auto">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`wf-tab-${k}`} className={`px-4 py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors duration-200 ${tab === k ? "border-gold text-white" : "border-transparent text-slate-400 hover:text-white"}`}>{l}</button>
        ))}
      </div>
      {!data ? null : tab === "scores" ? <ScoresTab data={data} reload={load} />
        : tab === "suggestions" ? <SuggestionsTab onChange={load} />
        : tab === "rewards" ? <RewardsTab /> : <LeadHistoryTab />}
    </Layout>
  );
}
